import { render, staticRenderFns } from "./AddOnAddBenefitModal.vue?vue&type=template&id=5d810ac4&scoped=true"
import script from "./AddOnAddBenefitModal.vue?vue&type=script&lang=js"
export * from "./AddOnAddBenefitModal.vue?vue&type=script&lang=js"
import style0 from "./AddOnAddBenefitModal.vue?vue&type=style&index=0&id=5d810ac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d810ac4",
  null
  
)

export default component.exports